export const HOOKS = {
  EditUserFields: 'feature-users-web:edit-user-fields',
  UserUpdated: 'feature-users-web:user-updated',
}
